import clsx from 'clsx';
import React from 'react';

import imgPhone from 'images/pro/Phone.png';
import imgTriangleTop from 'images/pro/TriangleTop.svg';

import useCurrentUser from '../../hooks/useCurrentUser';
import { subscribe_promotion_path, upgrade_subscription_path } from '../../routes';
import {
  DEFAULT_ANNUAL_OFFER_CODE,
  DEFAULT_MONTHLY_OFFER_CODE,
  DEFAULT_PRO_OFFER_CODE,
  DEFAULT_YP_OFFER_CODE,
} from '../../src/constants';

const ProHero = () => {
  const { currentUser } = useCurrentUser();
  const isCurrentUserSubscriber = currentUser?.is_subscriber;
  const isCurrentUserProSubscriber = currentUser?.is_pro_subscriber;

  return (
    <div className="px-16 xs:px-48 my-32 md:mt-72">
      <div className="flex md:max-w-[1024px] mx-auto relative">
        <div className="sm:max-w-[458px] md:max-w-[524px]">
          <p className="font-sans text-overline text-primary-red uppercase m-0">
            {isCurrentUserSubscriber && !isCurrentUserProSubscriber
              ? 'Upgrade now'
              : !isCurrentUserSubscriber && 'Subscribe'}
          </p>
          <h2 className="font-serif md-d:text-[32px] text-headline-lg text-primary-black m-0 mt-16">
            Don{'’'}t read the news.
            <br />
            Make the news.
            <br />
            The Information Pro.
          </h2>
          <p className="text-paragraph font-serif text-black m-0 mt-16">
            The Information Pro is a new service for professionals who need non-public resources to
            excel at their jobs. You{'’'}ll have access to the resources we built for
            ourselves—because we couldn{'’'}t find them anywhere else. Don{'’'}t take a meeting
            without The Information Pro.
          </p>
          {!isCurrentUserProSubscriber && (
            <a
              href={
                isCurrentUserSubscriber
                  ? upgrade_subscription_path()
                  : subscribe_promotion_path({
                      offer: `${DEFAULT_PRO_OFFER_CODE},${DEFAULT_ANNUAL_OFFER_CODE},${DEFAULT_MONTHLY_OFFER_CODE},${DEFAULT_YP_OFFER_CODE}`,
                    })
              }
              className={clsx(
                'text-button-md font-sans !text-white bg-primary-red uppercase',
                'xs:w-[245px] h-40 flex items-center justify-center rounded-r-2 mt-24 md:mt-32',
                'hover:bg-pro-red focus:bg-pro-red transition-colors'
              )}
            >
              {isCurrentUserSubscriber ? 'Upgrade' : 'Get Started'}
            </a>
          )}
        </div>
        <div className="absolute -top-24 md:-top-40 left-[150px] sm:left-auto sm:-right-[100px] mix-blend-multiply w-full xs:w-auto">
          <img className="block object-contain object-top w-full" src={imgTriangleTop} alt="" />
        </div>
        <div className="hidden sm:block absolute right-0 -top-24 sm:left-[600px] w-[275px] md:w-[325px]">
          <img className="block object-contain object-top w-full" src={imgPhone} alt="" />
        </div>
        <div className="hidden sm:block w-[275px] shrink-0" />
      </div>
    </div>
  );
};

export default ProHero;
